import React, { Children } from 'react';
import Form from "semantic-ui-react/dist/es/collections/Form/Form.js";
import { getClonedInput } from "./getClonedInput";
export var getFormChild = function getFormChild(child, parent) {
  if (!child) return child;

  if (typeof child === 'string') {
    return React.createElement(Form.Field, {
      children: child
    });
  }

  if (child.type === Form.Group) {
    return React.cloneElement(child, {
      children: Children.map(child.props.children, function (nestedChild) {
        return getFormChild(nestedChild, parent);
      }),
      widths: 'equal'
    });
  }

  return getClonedInput(child, parent);
};